import { render, staticRenderFns } from "./ppm_yearly_export.vue?vue&type=template&id=60ebff2f&scoped=true"
import script from "./ppm_yearly_export.vue?vue&type=script&lang=ts"
export * from "./ppm_yearly_export.vue?vue&type=script&lang=ts"
import style0 from "./ppm_yearly_export.vue?vue&type=style&index=0&id=60ebff2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ebff2f",
  null
  
)

export default component.exports